import { toFull } from "./paths";
import { setChoice, setSessionFull } from "./version-core";

/**
 * «Полная версия» в «Ещё» и профиле — явный выбор (FR-005, US4-1): запоминается на устройстве,
 * пока пользователь не выберет «Мобильная версия». Без выбора встроенный скрипт полной версии
 * вернул бы телефон обратно в мобильную.
 *
 * Адрес — как в `toFull`: с заглушки «в полной версии» это её `to`, с остальных экранов —
 * обратное соответствие из таблицы адресов, иначе `/`. Сеанс общий (cookie), повторный
 * вход не нужен.
 *
 * @param mobilePath адрес экрана, с которого уходим (с префиксом `/mobile` или без него)
 */
export function goFull(
    mobilePath: string,
    assign: (url: string) => void = (url) => window.location.assign(url)
): void {
    setChoice("full");
    assign(toFull(mobilePath));
}

/**
 * Открыть страницу в полной версии без смены выбора (FR-005, FR-014): заглушка раздела,
 * колокольчик, «Нет доступа», «Не найдено», стартовые данные. Полная версия действует только
 * в этой вкладке (окне приложения) — `sessionStorage`; в новой вкладке и при следующем запуске
 * телефон снова попадёт в мобильную версию.
 */
export function openInFull(
    mobilePath: string,
    assign: (url: string) => void = (url) => window.location.assign(url)
): void {
    setSessionFull(true);
    assign(toFull(mobilePath));
}

/**
 * Перейти из полной версии в мобильную (FR-006, FR-033): запомнить выбор на устройстве и открыть
 * `/mobile/open?to=<текущий путь>` — мобильная версия сама подберёт аналог раздела или заглушку.
 * Вызывается только на телефоне (ссылка в меню пользователя).
 */
export function goMobile(
    location: { pathname: string; search: string } = window.location,
    assign: (url: string) => void = (url) => window.location.assign(url)
): void {
    setChoice("mobile");
    // отметка «полная на эту вкладку» больше не нужна: пользователь сам вернулся в мобильную
    setSessionFull(false);
    assign("/mobile/open?to=" + encodeURIComponent(location.pathname + location.search));
}
